











































export default {
    name: 'FilterDropdown',
    setup() {
        const isOpen = ref(false);

        return { isOpen };
    },

    props: {
        type: {
            required: true,
            type: String,
        },
        options: {
            required: true,
            type: Array,
        },
        value: {
            required: false,
            type: String,
        },
    },

    methods: {
        updateValue(value) {
            if (value === this.value) {
                value = null;
            }
            this.$emit('input', value);
            this.isOpen = false;
        },
    },
};
